export class LanguageConfigurations {
  static readonly SESSION_IS_OVER = 'The session is over.';
  static readonly SESSION_IS_OVER_PAGE_REDIRECTION = 'You will be redirected in'; // x seconds
}
